import React, { useEffect, useState } from 'react';
import AmbientAudioPlayer from './ambient-audio-player';
import Transcription from './transcription';
import NavBar from './nav-bar';
import FloorMap from './floor-map';

const Room = ({ id, style, objects, decorations, ambient, soundbite }) => {

    const MIN_WIDTH = 800;

    const resize = () => {
        const roomDiv = document.getElementById(id);
        const sidebarDiv = document.getElementById('explore-sidebar');
        if (roomDiv && sidebarDiv) {
            const width = Math.max(window.innerWidth - sidebarDiv.offsetWidth, MIN_WIDTH);
            const height = (2160 / 2800) * width;
            roomDiv.style.setProperty('width', `${width}px`);
            roomDiv.style.setProperty('height', `${height}px`);
        }
    }

    useEffect(() => {
        resize();
        window.addEventListener('resize', resize);
    });

    function setVh() {
    const vh = window.innerHeight * 0.01; // 1% of viewport height
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    console.log('vh set');
    }
    
    // Initial call
    setVh();

    function animateScroll(element, target, duration = 500) {
        const start = element.scrollLeft;
        const change = target - start;
        const startTime = performance.now();
        
        function animate(currentTime) {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            // Optional easing function (easeInOut)
            const easedProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        
            element.scrollLeft = start + change * easedProgress;
        
            if (progress < 1) {
            window.requestAnimationFrame(animate);
            }
        }
        
        window.requestAnimationFrame(animate);
    }

    setTimeout(function() {
        const entranceElement = document.getElementById('entrance');
        const roomElement = document.getElementsByClassName('room-container')[0];
        if (entranceElement) {
            console.log(roomElement);
            const scrollLeft = (roomElement.scrollWidth - roomElement.clientWidth) / 2;
            console.log(scrollLeft);
            //roomElement.scrollLeft = scrollLeft;
            animateScroll(roomElement, scrollLeft, 1500);
        }
    }, 100);
    

    return (
        <div id={id} style={style} className='room'>
            <NavBar room={id}/>
            <FloorMap room={id}/>
            {objects.map(o => {
                return (
                    <div 
                        className='room-object' 
                        id={o.id} 
                        key={o.id} 
                        tabIndex='0'>
                            {o.component}
                    </div>
                )
            })}
            {decorations.map(d => <div className='room-decoration' id={d.id} key={d.id}>{d.component}</div>)}
            {soundbite && <Transcription text={soundbite.transcription} citation={soundbite.citation}/>}
        </div>
    )
}

export default Room;